var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('user-avatar',{attrs:{"user":_vm.viewer.conn_info}})}
var staticRenderFns = []

export { render, staticRenderFns }